import { Paperclip } from "lucide-react";
import { motion } from "motion/react";
import { useTranslations } from "next-intl";

import Image from "next/image";
import { Link } from "@/i18n/navigation";

interface WelcomeMessageProps {
	mounted: boolean;
}

export function WelcomeMessage({ mounted }: WelcomeMessageProps) {
	const t = useTranslations("aiBuilder");
	return (
		<motion.div
			animate={{ opacity: 1, y: 0 }}
			className="flex flex-col items-center gap-4 py-8 text-center"
			initial={{ opacity: 0, y: 20 }}
		>
			<div className="flex size-12 items-center justify-center rounded-2xl bg-primary/10">
				<Link href="/">
					<Image
						alt="forms.projme"
						className={"pointer-events-none"}
						height={69}
						src="/android-chrome-192x192.png"
						width={69}
					/>
				</Link>
			</div>
			<h2 className="font-semibold text-2xl" id="welcome-heading">
				{t("welcome.title")}
			</h2>
			<p
				aria-describedby="welcome-heading"
				className="max-w-md text-muted-foreground text-sm"
			>
				{t("welcome.subtitle")}
				<br />
				{t("welcome.prompt")}
			</p>
			<div className="flex items-center gap-1.5 rounded-full bg-muted px-3 py-1 text-muted-foreground text-xs">
				<Paperclip aria-hidden="true" className="size-3 shrink-0" />
				{t("welcome.fileHint")}
			</div>
		</motion.div>
	);
}
